export default {
  title: `إتقان أساسيات البرمجة<br /> من الصياغة إلى الحلول`,
  fundamentalsTitle: "المبادئ الأساسية للبرمجة",
  fundamentalsContent: `البرمجة هي فن ترجمة الأفكار البشرية إلى لغة يمكن للحواسيب فهمها. في هذه section، سنغطي اللبنات الأساسية الضرورية للبرمجة، بما في ذلك <b>المتغيرات</b>، <b>أنواع البيانات</b>، <b>هياكل التحكم</b>، و<b>الدوال</b>.
            <br />
            <br />
            سيتم تقديم مفاهيم رئيسية مثل <b>العبارات الشرطية</b> (if-else)، <b>الحلقات</b> (for و while)، و<b>معالجة الأخطاء</b>، مما يوفر للطلاب الأدوات للتحكم في تدفق برامجهم. ستساعد تمارين البرمجة العملية في تعزيز هذه المبادئ، مما يسمح للطلاب بممارسة كتابة وتصحيح برامج بسيطة.
            <br />
            <br />
            بحلول نهاية هذه section، سيكون لدى المشاركين فهم راسخ لمكونات البرمجة الأساسية، مما يعدهم لإنشاء تطبيقات وظيفية ومواجهة تحديات برمجة أكثر تعقيدًا.`,
  advancedTitle: "مقدمة إلى الخوارزميات وحل المشكلات",
  advancedContent: `بمجرد فهم المفاهيم الأساسية، سنحول تركيزنا إلى الخوارزميات وتقنيات حل المشكلات. يركز هذا الجزء على أهمية التفكير الخوارزمي في البرمجة ويقدم استراتيجيات حل المشكلات الأساسية.
            <br />
            <br />
            تشمل المواضيع التي سيتم تناولها <b>تصميم الخوارزميات</b>، <b>تحليل التعقيد</b>، وخوارزميات شائعة مثل <b>الفرز</b> و<b>البحث</b>. سيشارك الطلاب في تمارين تتحدى لهم تطوير خوارزميات لمشكلات عملية، مما يعزز قدرتهم على التفكير النقدي وتحسين حلولهم.
            <br />
            <br />
            من خلال تحليل تحديات البرمجة المختلفة، سيتعلم المشاركون كيفية تقسيم المشكلات المعقدة إلى مكونات قابلة للإدارة، مما يعزز نهجًا منهجيًا في البرمجة سيفيدهم في مساعيهم البرمجية المستقبلية.`,
};
